module.exports = __webpack_public_path__ + "img/tablet.4991b453.png";